import { ActionTypes } from '../../actions/dashboard/events_index'

const {
  GET_EVENTS,
  GET_INITIAL_EVENTS,
  CHANGE_REGISTRATION_STATUS,
  PUBLISH_LEAGUE,
} = ActionTypes

const initialState = {
  events: [],
  numberOfLeagues: 0,
  totalGolfers: 0,
  totalAmount: 0,
}

const events = (state = initialState, action) => {
  switch (action.type) {
    case GET_EVENTS:
      return {
        ...state,
        events: [...state.events, ...action.data.events],
      }
    case GET_INITIAL_EVENTS: 
      return {
        ...state,
        events: action.data.events,
      }
    
    case CHANGE_REGISTRATION_STATUS: {
      const updatedEvents = state.events.map(event => {
        if (event.id === action.data.id) {
          return { ...event, isRegistrationOpen: action.data.newStatus }
        }
        return event
      },

      )
      return {
        ...state,
        events: updatedEvents,
      }
    }
    case PUBLISH_LEAGUE: {
      const updatedEvents = state.events.map(event => {
        if (event.id === action.data.id) {
          return { ...event, published: action.data.published, golfHubLink: action.data.golfHubLink }
        }
        return event
      },

      )
      return {
        ...state,
        events: updatedEvents,
      }
    }
    default:
      return state
  }
}

export default events
